/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalTooth from './dental-tooth';
import DentalToothDetail from './dental-tooth-detail';
import DentalToothUpdate from './dental-tooth-update';
import DentalToothDeleteDialog from './dental-tooth-delete-dialog';

const DentalToothRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalTooth />} />
    <Route path="new" element={<DentalToothUpdate />} />
    <Route path=":id">
      <Route index element={<DentalToothDetail />} />
      <Route path="edit" element={<DentalToothUpdate />} />
      <Route path="delete" element={<DentalToothDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalToothRoutes;
